/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResponseHistoryCallSearchingEvent = {
  type: "response.history_call.searching";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
};

/** @internal */
export const ResponseHistoryCallSearchingEvent$inboundSchema: z.ZodType<
  ResponseHistoryCallSearchingEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.history_call.searching"),
  sequence_number: z.number().int(),
  item_id: z.string(),
  output_index: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
    "item_id": "itemId",
    "output_index": "outputIndex",
  });
});
/** @internal */
export type ResponseHistoryCallSearchingEvent$Outbound = {
  type: "response.history_call.searching";
  sequence_number: number;
  item_id: string;
  output_index: number;
};

/** @internal */
export const ResponseHistoryCallSearchingEvent$outboundSchema: z.ZodType<
  ResponseHistoryCallSearchingEvent$Outbound,
  z.ZodTypeDef,
  ResponseHistoryCallSearchingEvent
> = z.object({
  type: z.literal("response.history_call.searching"),
  sequenceNumber: z.number().int(),
  itemId: z.string(),
  outputIndex: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
    itemId: "item_id",
    outputIndex: "output_index",
  });
});

export function responseHistoryCallSearchingEventToJSON(
  responseHistoryCallSearchingEvent: ResponseHistoryCallSearchingEvent,
): string {
  return JSON.stringify(
    ResponseHistoryCallSearchingEvent$outboundSchema.parse(
      responseHistoryCallSearchingEvent,
    ),
  );
}
export function responseHistoryCallSearchingEventFromJSON(
  jsonString: string,
): SafeParseResult<ResponseHistoryCallSearchingEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResponseHistoryCallSearchingEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseHistoryCallSearchingEvent' from JSON`,
  );
}
